import React, { useState, useEffect } from 'react';
import { FaQuoteLeft } from 'react-icons/fa';

const TaskTips = ({
  expandedContainer,
  onExpand,
  onClose,
  isExpandedInCenter,
}) => {
  const [quote, setQuote] = useState('');

  // Collection of 50 motivational quotes relevant to medical professionals
  const quotes = [
    "Doing one thing well beats juggling ten poorly.",
  "A clear to-do list beats relying on memory—brains can be sketchy.",
  "Every task you complete is a mini victory—celebrate quietly (or loudly).",
  "Take short breaks; your brain isn't a machine, even if it feels like one.",
  "If a task takes less than two minutes, don't think, just do it.",
  "Your future self prefers organized notes, trust me.",
  "Good decisions usually start with clear priorities.",
  "When in doubt, simplify your task list—clarity beats complexity.",
  "Multitasking often means doing multiple things badly. Stick to one.",
  "Consistency creates success faster than occasional bursts of genius.",
  "Coffee is great, sleep is better—don't mix them up.",
  "One focused hour beats a day of distracted activity.",
  "Tasks done early mean guilt-free evenings.",
  "Big tasks become easier when split into bite-sized chunks.",
  "Deadlines aren't suggestions; they're survival tools.",
  "Write things down—your brain thanks you in advance.",
  "Efficient people do boring things quickly. Just get them over with.",
  "Be realistic: overly ambitious lists make great guilt trips.",
  "Organize today, or search desperately tomorrow.",
  "Your calendar is your best friend; treat it well.",
  "Review your day briefly each evening to improve tomorrow.",
  "Mistakes are lessons—make notes so you don’t repeat classes.",
  "Productivity isn’t about doing more, it’s doing meaningful things well.",
  "Always clarify expectations; guessing rarely ends well.",
  "Complex tasks are just a series of simpler tasks dressed fancy.",
  "If procrastination knocks, tell it you're busy.",
  "Prioritize ruthlessly; not everything matters equally.",
  "Practice saying 'no'—it frees up space for important 'yeses'.",
  "Stay hydrated—brains run better on water than caffeine (unfortunately).",
  "Avoid perfectionism; 'finished' is usually better than 'perfect'.",
  "Tidy workspace, tidy mind, fewer embarrassing desk disasters.",
  "Review your goals weekly to avoid accidentally wandering off track.",
  "Work smarter, not longer—your future self appreciates free time.",
  "Small daily habits create big long-term results.",
  "Keep your task list visible; out of sight often means out of mind.",
  "Breaks aren’t lazy—they recharge your efficiency battery.",
  "Routine reduces decision fatigue; save brainpower for real problems.",
  "Double-check details early—later usually means too late.",
  "Distraction-proof your workspace; cat videos can wait (sadly).",
  "When stuck, switch tasks briefly; your subconscious will keep working.",
  "Ask for help when tasks pile up—being overwhelmed isn't heroic.",
  "Celebrate small achievements; they're stepping stones to bigger goals.",
  "Identify your peak productivity hours—guard them fiercely.",
  "Good enough beats incomplete every single time.",
  "If your plan isn't working, adapt rather than abandon ship.",
  "Keep meetings short; no one ever complained a meeting was too brief.",
  "Be punctual; lateness steals everyone’s time—including yours.",
  "Label files clearly; cryptic names aren’t fun puzzles later on.",
  "Reward your progress regularly—motivation loves treats.",
  "Balance seriousness with humor—it makes the workload lighter."
  ];

  // Select a random quote when component mounts
  useEffect(() => {
    const randomIndex = Math.floor(Math.random() * quotes.length);
    setQuote(quotes[randomIndex]);
  }, []);

  return (
    <div className="info-box task-tips">
      <h4>Daily Inspiration</h4>
      <div className="tip-preview">
        <FaQuoteLeft className="tip-icon" />
        <p className="quote-text">{quote}</p>
      </div>

      <style jsx>{`
        .info-box {
          background: #fff;
          border-radius: 12px;
          padding: 1.5rem;
          position: relative;
          transition: all 0.3s ease;
        }

        h4 {
          margin-top: 0;
          margin-bottom: 1rem;
          font-size: 0.9rem;
          font-weight: 600;
          color: #4a5568;
        }

        .tip-preview {
          display: flex;
          align-items: flex-start;
          gap: 1rem;
          padding: 0.75rem;
          background: #f8fafc;
          border-radius: 8px;
        }

        .tip-icon {
          color: #3b82f6;
          font-size: 1.25rem;
          flex-shrink: 0;
          margin-top: 0.2rem;
        }

        .quote-text {
          color: #4b5563;
          font-size: 0.875rem;
          line-height: 1.5;
          font-style: italic;
          margin: 0;
        }
      `}</style>
    </div>
  );
};

export default TaskTips;